import React, { useState } from "react";
import concerto45 from "../imgs/Concerto 4-5 ottobre.jpg";
import Locandinagennaio from "../imgs/locandina10gennaio.jpg";
import openday from "../imgs/openday.jpg";
import colorimusica from "../imgs/i colori della musica.jpg";
import { BsMusicNoteList } from "react-icons/bs";
import concerto22novembre from "../imgs/Concerto22Novembre2025.jpg";
import locNatale from "../imgs/Locandina natale 2.jpg";

const Concerti = () => {
  const [fullScreenImage, setFullScreenImage] = useState(null);

  const handleImageClick = (image) => {
    setFullScreenImage(image);
  };

  const handleClose = () => {
    setFullScreenImage(null);
  };

  return (
    <div className="flex flex-col items-center  px-4 bg-gradient-to-r from-white to-amber-50">
      <BsMusicNoteList className="fixed text-amber-200/40 text-[180px] rotate-12 -top-5 -right-5 z-0" />

      <h1 className="text-red-600 font-extrabold text-3xl md:text-4xl mt-5 tracking-wide z-10">
        CONCERTI
      </h1>
      <div className="text-center text-lg mb-8 mt-5 z-10">
        <ul className="space-y-4 text-gray-800">
          <li className="flex items-start justify-center gap-2">
            <span className=" text-red-500">📍</span>
            <span>
              <strong>14 Dicembre -</strong> presso la Chiesa di{" "}
              <em>San Luigi Gonzaga Milano M3 Brenta</em>
            </span>
          </li>
        </ul>
      </div>

      <div className="flex flex-row flex-wrap justify-center gap-6 w-full max-w-6xl mb-3">
        {[locNatale].map((image, index) => (
          <img
            key={index}
            src={image}
            className="w-[300px] sm:w-[40%] h-auto rounded-lg shadow-lg cursor-pointer transform hover:scale-105 transition-transform duration-500 ease-in-out"
            alt={`Locandina ${index + 1}`}
            onClick={() => handleImageClick(image)}
          />
        ))}
      </div>

      {fullScreenImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50"
          onClick={handleClose}
        >
          <img
            src={fullScreenImage}
            className="max-w-full max-h-full rounded-lg shadow-lg"
            alt="Ingrandimento"
          />
        </div>
      )}
    </div>
  );
};

export default Concerti;
